// extracted by mini-css-extract-plugin
export default {"hideTooltip":"E8-z","fadeIn":"F8-z","delay":"G8-z","recommendedSizeTooltip":"H8-z"};